<template>
  <layout-quarter bg="/images/photo-4.jpg">
    <template v-slot:nav>
      <navigation :showFilter="true" />
    </template>
    
    <template v-if="totalPropertiesCount > 0">
      <transition-group class="stack" :name="transition" tag="div">
        <card-property 
          class="cycle-item"
          v-for="property of propertiesToShow"
          :key="property.MLS"
          :property="property"
          @left="handleDislike"
          @right="handleLike"
        />
      </transition-group>

      <div class="button-group actions">
        <button type="button" @click="handleDislike">
          <img src="@/assets/icons/dislike.svg" alt="">
        </button>

        <router-link type="button" tag="button" :to="`/properties/${ currentProperty.MLS }`">
          <img src="@/assets/icons/info.svg" alt="">
        </router-link>

        <button type="button" @click="handleLike">
          <img src="@/assets/icons/like.svg" alt="">
        </button>
      </div>
    </template>

    <template v-else>
      <template v-if="searchMeta.NumberOfReturnedListings < searchMeta.TotalSearchResults">
        <h1 class="heading h2 t-inverse t-center">End of Search</h1>
        <p>Do you want to keep going?</p>
        <button type="button" class="button" @click="searchProperties">Search for more</button>
      </template>

      <template v-else>
        <h1 class="heading h2 t-inverse t-center">No More Properties</h1>
        <p class="t-center">Refine your search and try again or view your favourited properties.</p>
      </template>

      <router-link class="button" to="/user/favourites" v-if="likedPropertiesCount > 0">Review favourite properties</router-link>
      <router-link class="button button--link" to="/wizard">Refine search</router-link>
    </template>
  </layout-quarter>
</template>

<style scoped lang="scss">
  .heading {
    margin-bottom: 100px;

    @include min-sm {
      margin-top: 90px;
      margin-bottom: 250px;
    }
  }

  .stack {
    position: relative;
    height: 400px;
    width: 100%;
    margin-bottom: 10px;

    @include min-sm {
      height: 450px;
      width: 405px;
      margin-bottom: 30px;
    }

    .card {
      position: absolute;
      transform-origin: center top;
      pointer-events: none;

      &:nth-child(1) {
        z-index: 3;
        transform: translateY(23px) scale(1);
        pointer-events: auto;
      }

      &:nth-child(2) {
        z-index: 2;
        opacity: 0.9;
        transform:  translateY(10px) scale(0.9);
      }

      &:nth-child(3) {
        z-index: 1;
        opacity: 0.7;
        transform: scale(0.7);
      }

      &:nth-child(4) {
        z-index: 0;
        opacity: 0;
        transform: scale(0);
      }
    }

    .cycle-item {
      transition: transform 0.5s, opacity 0.3s;
    }

    .cycle-dislike-leave-to {
      opacity: 0;
      
      transform: translateX(-100%) rotate(-45deg) scale(0.75) !important;

      @include min-sm {
        transform: translateX(-100%) rotate(-45deg) scale(0.75) !important;
      }
    }

    .cycle-like-leave-to {
      opacity: 0;
      
      transform: translateX(100%) rotate(45deg) scale(0.75) !important;

      @include min-sm {
        transform: translateX(100%) rotate(45deg) scale(0.75) !important;
      }
    }
  }

  .actions {
    img {
      width: 90px;

      @include min-sm {
        width: auto;
      }
    }
  }
</style>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  import LayoutQuarter from '@/layouts/Quarter';
  import Navigation from '@/components/Navigation';
  import CardProperty from '@/components/CardProperty';

  export default {
    name: 'Properties',

    components: {
      LayoutQuarter,
      Navigation,
      CardProperty
    },

    data: () => ({
      transition: 'cycle-like'
    }),

    computed: {
      ...mapState([
        'properties',
        'searchMeta'
      ]),

      ...mapGetters([
        'likedPropertiesCount',
        'totalPropertiesCount'
      ]),

      propertiesToShow () {
        return this.properties.filter((el, i) => i < 3);
      },

      currentProperty () {
        return this.propertiesToShow[0];
      }
    },

    methods: {
      ...mapActions([
        'searchProperties',
        'addLikedProperty',
        'addDislikedProperty'
      ]),

      handleDislike () {
        this.transition = 'cycle-dislike';
        this.addDislikedProperty(this.currentProperty.MLS);
      },

      handleLike () {
        this.transition = 'cycle-like';
        this.addLikedProperty(this.currentProperty.MLS);
      }
    },

    created () {
      if (this.totalPropertiesCount === 0) this.searchProperties();
    }
  };
</script>